const validateDataProperty = (val) => {
	let validatedVal = val;

	/**
	 * Either enforce a space after each colon or enforce no space after
	 * each colon. If space is enforced, prevent invalid URL protocols
	 * due to validation.
	 */
	if (typeof validatedVal === 'string') {
		/*
		// spaceAfterColon was not used anywhere
		validatedVal = spaceAfterColon
			? validatedVal
					.replace(/:(?=[^\s])/g, ': ')
					.replace(/https?:\s+/gi, (protocolToFix) =>
						protocolToFix.trim()
					)
			: validatedVal.replace(/:\s+/g, ':');
		*/
		validatedVal = validatedVal.replace(/:\s+/g, ':').toLowerCase().trim();
	}

	return validatedVal;
};

const parseTemplateStrings = (map, str) => {
	let parsedStr = str;

	if (typeof parsedStr === 'string') {
		// replace templates in string denoted by {key}
		parsedStr = parsedStr.replace(
			/\{(.*?)\}/g,
			(match, key) => map[key] || ''
		);

		/**
		 * Remove all colons that are not eventually followed by
		 * text content ie. repeated colons and trailing colons.
		 */
		parsedStr = parsedStr.replace(/:\s{0,}(?!\s?[^:])/g, '');

		/*
		// ddctimb - can't figure out how to get a string to this point that gets into below if statement
		// check out the unit test lolol
		// set to empty string if string only contained templates
		// and no matches found
		if (/^:+$/g.test(parsedStr)) {
			parsedStr = '';
		}
		*/
	}

	return parsedStr;
};

const parseData = (map, payload) => {
	// copy original data object so modifications only affect copy
	const payloadCopy = JSON.parse(JSON.stringify(payload));

	// parse template strings in data payload
	if (typeof payloadCopy === 'object') {
		Object.keys(payloadCopy).forEach((prop) => {
			if (payloadCopy[prop] && typeof payloadCopy[prop] === 'object') {
				payloadCopy[prop] = parseData(map, payloadCopy[prop]);
			} else if (typeof payloadCopy[prop] === 'string') {
				payloadCopy[prop] = parseTemplateStrings(
					map,
					payloadCopy[prop]
				);

				/*
				 * Validate property value to meet Dealer Connection
				 * requirements. Remove blank properties from data payload.
				 */
				if (
					typeof payloadCopy[prop] === 'undefined' ||
					payloadCopy[prop] === ''
				) {
					delete payloadCopy[prop];
				} else {
					payloadCopy[prop] = validateDataProperty(payloadCopy[prop]);
				}
			}
		});
	}

	return payloadCopy;
};

export default parseData;
